// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest {
    static getAttributeTypeMap() {
        return ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest.attributeTypeMap;
    }
}
ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest.discriminator = undefined;
ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest.additionalProperties = false;
ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest.attributeTypeMap = [
    {
        "name": "start",
        "baseName": "start",
        "type": "number"
    },
    {
        "name": "pageSize",
        "baseName": "pageSize",
        "type": "number"
    },
    {
        "name": "searchModel",
        "baseName": "searchModel",
        "type": "MedicalClaimSearchModel"
    },
    {
        "name": "filterByClaimGroup",
        "baseName": "filterByClaimGroup",
        "type": "boolean"
    },
];
//# sourceMappingURL=claimV1ClaimMedicalClaimSearchMedicalClaimSearchRequest.js.map